import { useStorage } from "../storage";
import { useCallback } from "react";
export function useDataTableStorage(key, defaults) {
    const [storage, setStorage] = useStorage(key, Object.assign({ pageIndex: 0, pageSize: 10, sortDirection: "asc" }, defaults));
    const onPageChange = useCallback(({ pageSize, pageIndex }) => {
        setStorage(Object.assign(Object.assign({}, storage), { pageSize, pageIndex }));
    }, [storage]);
    const onSort = useCallback((field) => {
        if (storage.sortField == field) {
            setStorage(Object.assign(Object.assign({}, storage), { sortDirection: storage.sortDirection == "desc" ? "asc" : "desc" }));
        }
        else {
            setStorage(Object.assign(Object.assign({}, storage), { sortDirection: "asc", sortField: field }));
        }
    }, [storage]);
    return Object.assign(Object.assign({}, storage), { onPageChange,
        onSort });
}
//# sourceMappingURL=useDataTableStorage.js.map